// Authentic destination photographs with source and license attribution.
export const LOCATION_PHOTOS = {
  "manikpur": {
    "image": "/media/destinations-20261019/manikpur.webp",
    "imageWidth": 1280,
    "imageHeight": 853,
    "imageSrcSet": "/media/destinations-20261019/manikpur-640.webp 640w, /media/destinations-20261019/manikpur.webp 1280w",
    "imageAlt": "Ganesh Bagh temple near Karwi, a sightseeing excursion from Manikpur",
    "landmarkCaption": "Ganesh Bagh near Karwi · excursion from Manikpur",
    "imagePosition": "center 40%",
    "credit": {
      "title": "Ganesh bagh.jpg",
      "author": "Harkirat Singh (Visualbyharkirat)",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Ganesh_bagh.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "satna": {
    "image": "/media/destinations-20261019/satna.webp",
    "imageWidth": 1280,
    "imageHeight": 960,
    "imageSrcSet": "/media/destinations-20261019/satna-640.webp 640w, /media/destinations-20261019/satna.webp 1280w",
    "imageAlt": "Ruins of Bharhut Stupa near Satna, Madhya Pradesh",
    "landmarkCaption": "Bharhut Stupa · near Satna",
    "imagePosition": "center",
    "credit": {
      "title": "Bharhut Stupa.JPG",
      "author": "LRBurdak",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Bharhut_Stupa.JPG",
      "license": "CC BY-SA 3.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "maihar": {
    "image": "/media/destinations-20261019/maihar.webp",
    "imageWidth": 1280,
    "imageHeight": 1600,
    "imageSrcSet": "/media/destinations-20261019/maihar-640.webp 640w, /media/destinations-20261019/maihar.webp 1280w",
    "imageAlt": "Maa Sharda Devi Temple in Maihar, Madhya Pradesh",
    "landmarkCaption": "Maa Sharda Devi Temple",
    "imagePosition": "center 60%",
    "credit": {
      "title": "Maa Sharda Temple, Maihar.jpg",
      "author": "RishiAgrahari95",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Maa_Sharda_Temple,_Maihar.jpg",
      "license": "CC0 1.0",
      "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "rewa": {
    "image": "/media/destinations-20261019/rewa.webp",
    "imageWidth": 1280,
    "imageHeight": 720,
    "imageSrcSet": "/media/destinations-20261019/rewa-640.webp 640w, /media/destinations-20261019/rewa.webp 1280w",
    "imageAlt": "Keoti Falls in Rewa district, Madhya Pradesh",
    "landmarkCaption": "Keoti Falls",
    "imagePosition": "center",
    "credit": {
      "title": "Keoti falls in Rewa, Madhya Pradesh.jpg",
      "author": "Syedzohaibullah",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Keoti_falls_in_Rewa,_Madhya_Pradesh.jpg",
      "license": "CC BY 3.0",
      "licenseUrl": "https://creativecommons.org/licenses/by/3.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "khajuraho": {
    "image": "/media/destinations-20261019/khajuraho.webp",
    "imageWidth": 1280,
    "imageHeight": 853,
    "imageSrcSet": "/media/destinations-20261019/khajuraho-640.webp 640w, /media/destinations-20261019/khajuraho.webp 1280w",
    "imageAlt": "Kandariya Mahadeva Temple at Khajuraho, Madhya Pradesh",
    "landmarkCaption": "Kandariya Mahadeva Temple",
    "imagePosition": "center",
    "credit": {
      "title": "Kandariya Mahadev temple (side view) Khajuraho Temple complex, UNESCO WHS, Madya Pradesh.jpg",
      "author": "Omkarshinde19",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Kandariya_Mahadev_temple_(side_view)_Khajuraho_Temple_complex,_UNESCO_WHS,_Madya_Pradesh.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "katni": {
    "image": "/media/destinations-20261019/katni.webp",
    "imageWidth": 1280,
    "imageHeight": 836,
    "imageSrcSet": "/media/destinations-20261019/katni-640.webp 640w, /media/destinations-20261019/katni.webp 1280w",
    "imageAlt": "Samadhi area of Vijayraghavgarh Fort in Katni district, Madhya Pradesh",
    "landmarkCaption": "Vijayraghavgarh Fort · Katni district",
    "imagePosition": "center",
    "credit": {
      "title": "Vijayraghav Fort 2 S-MP-130.jpg",
      "author": "Chincholkar",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Vijayraghav_Fort_2_S-MP-130.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "umaria": {
    "image": "/media/destinations-20261019/umaria.webp",
    "imageWidth": 1280,
    "imageHeight": 960,
    "imageSrcSet": "/media/destinations-20261019/umaria-640.webp 640w, /media/destinations-20261019/umaria.webp 1280w",
    "imageAlt": "Shesh Shaiya reclining Vishnu statue at Bandhavgarh in Umaria district",
    "landmarkCaption": "Shesh Shaiya, Bandhavgarh · Umaria district",
    "imagePosition": "center",
    "credit": {
      "title": "Shesh Shaiya 01.jpg",
      "author": "BluesyPete",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Shesh_Shaiya_01.jpg",
      "license": "CC BY-SA 3.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "bandhavgarh": {
    "image": "/media/destinations-20261019/bandhavgarh.webp",
    "imageWidth": 1280,
    "imageHeight": 853,
    "imageSrcSet": "/media/destinations-20261019/bandhavgarh-640.webp 640w, /media/destinations-20261019/bandhavgarh.webp 1280w",
    "imageAlt": "Bengal tiger in Bandhavgarh National Park, Madhya Pradesh",
    "landmarkCaption": "Bandhavgarh National Park",
    "imagePosition": "center",
    "credit": {
      "title": "Bengal tiger in Bandhavgarh National Park 01.jpg",
      "author": "Bernard Gagnon",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Bengal_tiger_in_Bandhavgarh_National_Park_01.jpg",
      "license": "CC BY 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "jabalpur": {
    "image": "/media/destinations-20261019/jabalpur.webp",
    "imageWidth": 1280,
    "imageHeight": 853,
    "imageSrcSet": "/media/destinations-20261019/jabalpur-640.webp 640w, /media/destinations-20261019/jabalpur.webp 1280w",
    "imageAlt": "Madan Mahal Fort in Jabalpur, Madhya Pradesh",
    "landmarkCaption": "Madan Mahal Fort",
    "imagePosition": "center",
    "credit": {
      "title": "Madan mahal.jpg",
      "author": "Chetansoni",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Madan_mahal.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "bhopal": {
    "image": "/media/destinations-20261019/bhopal.webp",
    "imageWidth": 1280,
    "imageHeight": 960,
    "imageSrcSet": "/media/destinations-20261019/bhopal-640.webp 640w, /media/destinations-20261019/bhopal.webp 1280w",
    "imageAlt": "Taj-ul-Masajid mosque in Bhopal, Madhya Pradesh",
    "landmarkCaption": "Taj-ul-Masajid",
    "imagePosition": "center",
    "credit": {
      "title": "Taj Ul Masajid, Bhopal.JPG",
      "author": "Abhishek Mishra (Abhishek727)",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Taj_Ul_Masajid,_Bhopal.JPG",
      "license": "CC BY-SA 3.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "indore": {
    "image": "/media/destinations-20261019/indore.webp",
    "imageWidth": 1280,
    "imageHeight": 848,
    "imageSrcSet": "/media/destinations-20261019/indore-640.webp 640w, /media/destinations-20261019/indore.webp 1280w",
    "imageAlt": "Rajwada Palace in Indore, Madhya Pradesh",
    "landmarkCaption": "Rajwada Palace",
    "imagePosition": "center",
    "credit": {
      "title": "Rajwada Indore.jpg",
      "author": "Er.abhinav",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Rajwada_Indore.jpg",
      "license": "CC BY-SA 3.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "gwalior": {
    "image": "/media/destinations-20261019/gwalior.webp",
    "imageWidth": 1280,
    "imageHeight": 960,
    "imageSrcSet": "/media/destinations-20261019/gwalior-640.webp 640w, /media/destinations-20261019/gwalior.webp 1280w",
    "imageAlt": "Walls and bastions of Gwalior Fort, Madhya Pradesh",
    "landmarkCaption": "Gwalior Fort",
    "imagePosition": "center",
    "credit": {
      "title": "Gwalior Fort - Perspective.jpg",
      "author": "Navneel neeraj",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Gwalior_Fort_-_Perspective.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "mauganj": {
    "image": "/media/destinations-20261019/mauganj.webp",
    "imageWidth": 500,
    "imageHeight": 278,
    "imageSrcSet": "/media/destinations-20261019/mauganj.webp 500w",
    "imageAlt": "Deotalab Shiv Temple in Mauganj district, Madhya Pradesh",
    "landmarkCaption": "Deotalab Shiv Temple · Mauganj district",
    "imagePosition": "center",
    "credit": {
      "title": "Deotalab Shiv Mandir.png",
      "author": "Maywe46",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Deotalab_Shiv_Mandir.png",
      "license": "CC0 1.0",
      "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "panna": {
    "image": "/media/destinations-20261019/panna.webp",
    "imageWidth": 1280,
    "imageHeight": 960,
    "imageSrcSet": "/media/destinations-20261019/panna-640.webp 640w, /media/destinations-20261019/panna.webp 1280w",
    "imageAlt": "Pandav Falls in Panna district, Madhya Pradesh",
    "landmarkCaption": "Pandav Falls · Panna district",
    "imagePosition": "center",
    "credit": {
      "title": "Pandav Falls.jpg",
      "author": "Sushil Panthri",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Pandav_Falls.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "chhatarpur": {
    "image": "/media/destinations-20261019/chhatarpur.webp",
    "imageWidth": 1200,
    "imageHeight": 1600,
    "imageSrcSet": "/media/destinations-20261019/chhatarpur-640.webp 640w, /media/destinations-20261019/chhatarpur.webp 1200w",
    "imageAlt": "Blue water inside Bhimkund cave in Chhatarpur district, Madhya Pradesh",
    "landmarkCaption": "Bhimkund · Chhatarpur district",
    "imagePosition": "center 62%",
    "credit": {
      "title": "Blue Water Caves.jpg",
      "author": "Hardanddeeps",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Blue_Water_Caves.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "karwi": {
    "image": "/media/destinations-20261019/karwi.webp",
    "imageWidth": 1280,
    "imageHeight": 810,
    "imageSrcSet": "/media/destinations-20261019/karwi-640.webp 640w, /media/destinations-20261019/karwi.webp 1280w",
    "imageAlt": "Ram Ghat on the Mandakini River at Chitrakoot, near Karwi",
    "landmarkCaption": "Ram Ghat, Chitrakoot · near Karwi",
    "imagePosition": "center",
    "credit": {
      "title": "Ramghat.jpg",
      "author": "LRBurdak at English Wikipedia",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Ramghat.jpg",
      "license": "CC BY-SA 3.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "chitrakoot": {
    "image": "/media/destinations-20261019/chitrakoot.webp",
    "imageWidth": 1280,
    "imageHeight": 720,
    "imageSrcSet": "/media/destinations-20261019/chitrakoot-640.webp 640w, /media/destinations-20261019/chitrakoot.webp 1280w",
    "imageAlt": "Ram Ghat riverfront at Chitrakoot on the Mandakini River",
    "landmarkCaption": "Ram Ghat",
    "imagePosition": "center",
    "credit": {
      "title": "Ramghat at chitrakoot.jpg",
      "author": "Engshubham",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Ramghat_at_chitrakoot.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "varanasi": {
    "image": "/media/destinations-20261019/varanasi.webp",
    "imageWidth": 1280,
    "imageHeight": 960,
    "imageSrcSet": "/media/destinations-20261019/varanasi-640.webp 640w, /media/destinations-20261019/varanasi.webp 1280w",
    "imageAlt": "Dashashwamedh Ghat beside the Ganges in Varanasi",
    "landmarkCaption": "Dashashwamedh Ghat",
    "imagePosition": "center",
    "credit": {
      "title": "Dashashwamedh Ghat Varanasi.jpg",
      "author": "Kasyap",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Dashashwamedh_Ghat_Varanasi.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "prayagraj": {
    "image": "/media/destinations-20261019/prayagraj.webp",
    "imageWidth": 1280,
    "imageHeight": 960,
    "imageSrcSet": "/media/destinations-20261019/prayagraj-640.webp 640w, /media/destinations-20261019/prayagraj.webp 1280w",
    "imageAlt": "Boats along the riverbank near Triveni Sangam in Prayagraj",
    "landmarkCaption": "Triveni Sangam",
    "imagePosition": "center",
    "credit": {
      "title": "Triveni Sangam Prayagraj.jpg",
      "author": "M27SHRA",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Triveni_Sangam_Prayagraj.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "shahdol": {
    "image": "/media/destinations-20261019/shahdol.webp",
    "imageWidth": 1200,
    "imageHeight": 1600,
    "imageSrcSet": "/media/destinations-20261019/shahdol-640.webp 640w, /media/destinations-20261019/shahdol.webp 1200w",
    "imageAlt": "Virateshwar Temple at Sohagpur in Shahdol, Madhya Pradesh",
    "landmarkCaption": "Virateshwar Temple",
    "imagePosition": "center 12%",
    "credit": {
      "title": "0101022 Virateshwar temple, Sohagpur, Madhya Pradesh 003.jpg",
      "author": "Ms Sarah Welch",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:0101022_Virateshwar_temple,_Sohagpur,_Madhya_Pradesh_003.jpg",
      "license": "CC0 1.0",
      "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "sagar": {
    "image": "/media/destinations-20261019/sagar.webp",
    "imageWidth": 1280,
    "imageHeight": 720,
    "imageSrcSet": "/media/destinations-20261019/sagar-640.webp 640w, /media/destinations-20261019/sagar.webp 1280w",
    "imageAlt": "Lakha Banjara Lake in Sagar, Madhya Pradesh",
    "landmarkCaption": "Lakha Banjara Lake",
    "imagePosition": "center",
    "credit": {
      "title": "Lakha Banjara Lake Sagar 01.jpg",
      "author": "Prateek Sharma (Splendidhazard)",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Lakha_Banjara_Lake_Sagar_01.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "damoh": {
    "image": "/media/destinations-20261019/damoh.webp",
    "imageWidth": 1280,
    "imageHeight": 960,
    "imageSrcSet": "/media/destinations-20261019/damoh-640.webp 640w, /media/destinations-20261019/damoh.webp 1280w",
    "imageAlt": "Samavasarana Jain Temple at Kundalpur in Damoh district, Madhya Pradesh",
    "landmarkCaption": "Kundalpur Jain Temples · Damoh district",
    "imagePosition": "center",
    "credit": {
      "title": "Samavasarana Jain temple, Kundalpur.jpg",
      "author": "Atishay",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Samavasarana_Jain_temple,_Kundalpur.jpg",
      "license": "CC BY-SA 3.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "lucknow": {
    "image": "/media/destinations-20261019/lucknow.webp",
    "imageWidth": 1280,
    "imageHeight": 960,
    "imageSrcSet": "/media/destinations-20261019/lucknow-640.webp 640w, /media/destinations-20261019/lucknow.webp 1280w",
    "imageAlt": "Rumi Darwaza gateway in Lucknow, Uttar Pradesh",
    "landmarkCaption": "Rumi Darwaza",
    "imagePosition": "center",
    "credit": {
      "title": "Rumi darwaza of Lucknow 04.JPG",
      "author": "Aditya somani",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Rumi_darwaza_of_Lucknow_04.JPG",
      "license": "CC BY-SA 3.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "kanpur": {
    "image": "/media/destinations-20261019/kanpur.webp",
    "imageWidth": 1280,
    "imageHeight": 628,
    "imageSrcSet": "/media/destinations-20261019/kanpur-640.webp 640w, /media/destinations-20261019/kanpur.webp 1280w",
    "imageAlt": "JK Temple, also called Radhakrishna Temple, in Kanpur",
    "landmarkCaption": "JK Temple",
    "imagePosition": "center",
    "credit": {
      "title": "JK Temple(Juggilal Kamlapati temple) is a temple in the Indian city of Kanpur.It is considered to be a unique blend of ancient and modern architecture.jpg",
      "author": "Udayraj18",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:JK_Temple(Juggilal_Kamlapati_temple)_is_a_temple_in_the_Indian_city_of_Kanpur.It_is_considered_to_be_a_unique_blend_of_ancient_and_modern_architecture.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "agra": {
    "image": "/media/destinations-20261019/agra.webp",
    "imageWidth": 1280,
    "imageHeight": 829,
    "imageSrcSet": "/media/destinations-20261019/agra-640.webp 640w, /media/destinations-20261019/agra.webp 1280w",
    "imageAlt": "Taj Mahal in Agra",
    "landmarkCaption": "Taj Mahal",
    "imagePosition": "0% 50%",
    "credit": {
      "title": "View of Taj Mahal, Agra.jpg",
      "author": "Rohit Sharma",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:View_of_Taj_Mahal,_Agra.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "bhimbetka": {
    "image": "/media/destinations-20261019/bhimbetka.webp",
    "imageWidth": 1280,
    "imageHeight": 853,
    "imageSrcSet": "/media/destinations-20261019/bhimbetka-640.webp 640w, /media/destinations-20261019/bhimbetka.webp 1280w",
    "imageAlt": "Prehistoric rock shelter and paintings at Bhimbetka",
    "landmarkCaption": "Bhimbetka rock shelters",
    "imagePosition": "center",
    "credit": {
      "title": "Rock Shelter at Bhimbetka.jpg",
      "author": "Varada Phadkay",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Rock_Shelter_at_Bhimbetka.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "chanderi": {
    "image": "/media/destinations-20261019/chanderi.webp",
    "imageWidth": 1280,
    "imageHeight": 854,
    "imageSrcSet": "/media/destinations-20261019/chanderi-640.webp 640w, /media/destinations-20261019/chanderi.webp 1280w",
    "imageAlt": "Chanderi Fort illuminated on a full moon night",
    "landmarkCaption": "Chanderi Fort",
    "imagePosition": "center",
    "credit": {
      "title": "Chanderi Fort-Chanderi-Madhya Pradesh-DSC 0268.jpg",
      "author": "Asit Jain",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Chanderi_Fort-Chanderi-Madhya_Pradesh-DSC_0268.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "rani-kamlapati-railway-station": {
    "image": "/media/destinations-20261019/rani-kamlapati-railway-station.webp",
    "imageWidth": 1280,
    "imageHeight": 960,
    "imageSrcSet": "/media/destinations-20261019/rani-kamlapati-railway-station-640.webp 640w, /media/destinations-20261019/rani-kamlapati-railway-station.webp 1280w",
    "imageAlt": "Exterior of Rani Kamlapati Railway Station in Bhopal",
    "landmarkCaption": "Rani Kamlapati Railway Station",
    "imagePosition": "center",
    "credit": {
      "title": "Outside view of Rani Kamlapati Railway Station 39.jpg",
      "author": "Suyash Dwivedi",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Outside_view_of_Rani_Kamlapati_Railway_Station_39.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "mandu": {
    "image": "/media/destinations-20261019/mandu.webp",
    "imageWidth": 1280,
    "imageHeight": 854,
    "imageSrcSet": "/media/destinations-20261019/mandu-640.webp 640w, /media/destinations-20261019/mandu.webp 1280w",
    "imageAlt": "Jahaz Mahal palace in Mandu",
    "landmarkCaption": "Jahaz Mahal",
    "imagePosition": "center",
    "credit": {
      "title": "Jahaz Mahal, Mandu, Madhya Pradesh.jpg",
      "author": "Jaithakurpix",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Jahaz_Mahal,_Mandu,_Madhya_Pradesh.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "kanha": {
    "image": "/media/destinations-20261019/kanha.webp",
    "imageWidth": 1280,
    "imageHeight": 720,
    "imageSrcSet": "/media/destinations-20261019/kanha-640.webp 640w, /media/destinations-20261019/kanha.webp 1280w",
    "imageAlt": "Bengal tiger in Kanha Tiger Reserve",
    "landmarkCaption": "Kanha Tiger Reserve",
    "imagePosition": "0% 50%",
    "credit": {
      "title": "Tiger in Kanha.jpg",
      "author": "Indranilghosh1303",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Tiger_in_Kanha.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "maheshwar": {
    "image": "/media/destinations-20261019/maheshwar.webp",
    "imageWidth": 1280,
    "imageHeight": 960,
    "imageSrcSet": "/media/destinations-20261019/maheshwar-640.webp 640w, /media/destinations-20261019/maheshwar.webp 1280w",
    "imageAlt": "Ahilya Fort and Ahilyeshwar temple above the Narmada at Maheshwar",
    "landmarkCaption": "Ahilya Fort and Narmada ghats",
    "imagePosition": "center",
    "credit": {
      "title": "0102321 Maheshwar Ghats and Fort, Ahilya Bai Monuments, Madhya Pradesh 055.jpg",
      "author": "Ms Sarah Welch",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:0102321_Maheshwar_Ghats_and_Fort,_Ahilya_Bai_Monuments,_Madhya_Pradesh_055.jpg",
      "license": "CC0 1.0",
      "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "ujjain": {
    "image": "/media/destinations-20261019/ujjain.webp",
    "imageWidth": 1280,
    "imageHeight": 720,
    "imageSrcSet": "/media/destinations-20261019/ujjain-640.webp 640w, /media/destinations-20261019/ujjain.webp 1280w",
    "imageAlt": "Mahakaleshwar Temple in Ujjain at night",
    "landmarkCaption": "Mahakaleshwar Temple",
    "imagePosition": "center",
    "credit": {
      "title": "Mahakaleshwar Temple, Ujjain.jpg",
      "author": "Ashverse",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Mahakaleshwar_Temple,_Ujjain.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "orchha": {
    "image": "/media/destinations-20261019/orchha.webp",
    "imageWidth": 1280,
    "imageHeight": 853,
    "imageSrcSet": "/media/destinations-20261019/orchha-640.webp 640w, /media/destinations-20261019/orchha.webp 1280w",
    "imageAlt": "Royal chhatris beside the Betwa River in Orchha at sunset",
    "landmarkCaption": "Royal Chhatris on the Betwa River",
    "imagePosition": "center",
    "credit": {
      "title": "Beautiful sunset at the Royal Chhatris of Orchha.jpg",
      "author": "Sharvarism",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Beautiful_sunset_at_the_Royal_Chhatris_of_Orchha.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "satpura": {
    "image": "/media/destinations-20261019/satpura.webp",
    "imageWidth": 1280,
    "imageHeight": 881,
    "imageSrcSet": "/media/destinations-20261019/satpura-640.webp 640w, /media/destinations-20261019/satpura.webp 1280w",
    "imageAlt": "River crossing towards Satpura Reserve at dawn",
    "landmarkCaption": "Satpura National Park river landscape",
    "imagePosition": "center",
    "credit": {
      "title": "Crossing the river to Satpura Reserve at Dawn. - Flickr - gailhampshire.jpg",
      "author": "gailhampshire",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Crossing_the_river_to_Satpura_Reserve_at_Dawn._-_Flickr_-_gailhampshire.jpg",
      "license": "CC BY 2.0",
      "licenseUrl": "https://creativecommons.org/licenses/by/2.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "sanchi": {
    "image": "/media/destinations-20261019/sanchi.webp",
    "imageWidth": 1280,
    "imageHeight": 851,
    "imageSrcSet": "/media/destinations-20261019/sanchi-640.webp 640w, /media/destinations-20261019/sanchi.webp 1280w",
    "imageAlt": "Great Stupa at Sanchi in Madhya Pradesh",
    "landmarkCaption": "Great Stupa of Sanchi",
    "imagePosition": "center",
    "credit": {
      "title": "Sanchi Stupa, Sanchi, Madhya Pradesh.jpg",
      "author": "Suvro Banerjee",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Sanchi_Stupa,_Sanchi,_Madhya_Pradesh.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "bhedaghat": {
    "image": "/media/destinations-20261019/bhedaghat.webp",
    "imageWidth": 1280,
    "imageHeight": 960,
    "imageSrcSet": "/media/destinations-20261019/bhedaghat-640.webp 640w, /media/destinations-20261019/bhedaghat.webp 1280w",
    "imageAlt": "White Marble Rocks along the Narmada River at Bhedaghat",
    "landmarkCaption": "Marble Rocks on the Narmada",
    "imagePosition": "center",
    "credit": {
      "title": "Marble Rocks at Bhedaghat.jpg",
      "author": "Sandyadav080",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Marble_Rocks_at_Bhedaghat.jpg",
      "license": "CC BY-SA 3.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "sidhi": {
    "imageAlt": "Bengal tiger in Sanjay-Dubri Tiger Reserve, Sidhi district, Madhya Pradesh",
    "landmarkCaption": "Sanjay-Dubri Tiger Reserve · Sidhi district",
    "imagePosition": "center",
    "credit": {
      "title": "Bengal tiger in Sanjay Dubri Tiger Reserve December 2024 by Tisha Mukherjee 11.jpg",
      "author": "Tisha Mukherjee",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Bengal_tiger_in_Sanjay_Dubri_Tiger_Reserve_December_2024_by_Tisha_Mukherjee_11.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    },
    "image": "/media/destinations-20261019/sidhi.webp",
    "imageWidth": 1280,
    "imageHeight": 853,
    "imageSrcSet": "/media/destinations-20261019/sidhi-640.webp 640w, /media/destinations-20261019/sidhi.webp 1280w"
  },
  "singrauli": {
    "imageAlt": "Rock-cut Mada Caves and stone steps in Singrauli district, Madhya Pradesh",
    "landmarkCaption": "Mada Caves · Singrauli district",
    "imagePosition": "center",
    "credit": {
      "title": "Mada Caves, Singrauli.jpg",
      "author": "Dharmendragudia; Commons edit by R8cocin8",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Mada_Caves,_Singrauli.jpg",
      "license": "CC BY-SA 3.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/",
      "changes": "Resized and converted to WebP from the current Commons version; display may be cropped. Licensed as shown."
    },
    "image": "/media/destinations-20261019/singrauli.webp",
    "imageWidth": 1280,
    "imageHeight": 721,
    "imageSrcSet": "/media/destinations-20261019/singrauli-640.webp 640w, /media/destinations-20261019/singrauli.webp 1280w"
  },
  "ayodhya": {
    "image": "/media/destinations-20261022/ayodhya.webp",
    "imageWidth": 1440,
    "imageHeight": 844,
    "imageSrcSet": "/media/destinations-20261022/ayodhya-640.webp 640w, /media/destinations-20261022/ayodhya.webp 1440w",
    "imageAlt": "Ram Mandir in Ayodhya decorated with flowers during its January 2024 consecration",
    "landmarkCaption": "Ram Mandir",
    "imagePosition": "center",
    "credit": {
      "title": "Ram Mandir, Ayodhya.png",
      "author": "Narendra Modi (YouTube channel); cropped by Benison",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Ram_Mandir,_Ayodhya.png",
      "license": "CC BY 3.0",
      "licenseUrl": "https://creativecommons.org/licenses/by/3.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "mathura": {
    "image": "/media/destinations-20261022/mathura.webp",
    "imageWidth": 1440,
    "imageHeight": 960,
    "imageSrcSet": "/media/destinations-20261022/mathura-640.webp 640w, /media/destinations-20261022/mathura.webp 1440w",
    "imageAlt": "Boats beside Vishram Ghat on the Yamuna River in Mathura at dusk",
    "landmarkCaption": "Vishram Ghat",
    "imagePosition": "center",
    "credit": {
      "title": "Vishram Ghat.jpg",
      "author": "Umang108",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Vishram_Ghat.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "jaipur": {
    "image": "/media/destinations-20261022/jaipur.webp",
    "imageWidth": 1440,
    "imageHeight": 1028,
    "imageSrcSet": "/media/destinations-20261022/jaipur-640.webp 640w, /media/destinations-20261022/jaipur.webp 1440w",
    "imageAlt": "Hawa Mahal palace façade in Jaipur, Rajasthan",
    "landmarkCaption": "Hawa Mahal",
    "imagePosition": "center top",
    "credit": {
      "title": "Hawa Mahal. Jaipur.jpg",
      "author": "Ajit Kumar Majhi",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Hawa_Mahal._Jaipur.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "udaipur": {
    "image": "/media/destinations-20261022/udaipur.webp",
    "imageWidth": 1440,
    "imageHeight": 900,
    "imageSrcSet": "/media/destinations-20261022/udaipur-640.webp 640w, /media/destinations-20261022/udaipur.webp 1440w",
    "imageAlt": "Lake Pichola at sunset in Udaipur, Rajasthan, with the Lake Palace on the right",
    "landmarkCaption": "Lake Pichola",
    "imagePosition": "center",
    "credit": {
      "title": "Lake Pichola at sunset, Udaipur, Rajasthan, India.jpg",
      "author": "UnpetitproleX",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Lake_Pichola_at_sunset,_Udaipur,_Rajasthan,_India.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "jodhpur": {
    "image": "/media/destinations-20261022/jodhpur.webp",
    "imageWidth": 1440,
    "imageHeight": 710,
    "imageSrcSet": "/media/destinations-20261022/jodhpur-640.webp 640w, /media/destinations-20261022/jodhpur.webp 1440w",
    "imageAlt": "Mehrangarh Fort above Jodhpur, Rajasthan",
    "landmarkCaption": "Mehrangarh Fort",
    "imagePosition": "center",
    "credit": {
      "title": "Mehrangarh Fort jodhpur.jpg",
      "author": "Suncity rajasthan",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Mehrangarh_Fort_jodhpur.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "jaisalmer": {
    "image": "/media/destinations-20261022/jaisalmer.webp",
    "imageWidth": 1440,
    "imageHeight": 810,
    "imageSrcSet": "/media/destinations-20261022/jaisalmer-640.webp 640w, /media/destinations-20261022/jaisalmer.webp 1440w",
    "imageAlt": "Jaisalmer Fort in Rajasthan",
    "landmarkCaption": "Jaisalmer Fort",
    "imagePosition": "center",
    "credit": {
      "title": "Jaisalmer Fort, Jaisalmer, Rajasthan.jpg",
      "author": "Alvin Antony 910",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Jaisalmer_Fort%2C_Jaisalmer%2C_Rajasthan.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "new-delhi": {
    "image": "/media/destinations-20261022/new-delhi.webp",
    "imageWidth": 1440,
    "imageHeight": 958,
    "imageSrcSet": "/media/destinations-20261022/new-delhi-640.webp 640w, /media/destinations-20261022/new-delhi.webp 1440w",
    "imageAlt": "India Gate illuminated against a blue and purple evening sky in New Delhi",
    "landmarkCaption": "India Gate",
    "imagePosition": "center",
    "credit": {
      "title": "The India Gate, New Delhi (5621259188).jpg",
      "author": "Larry Johnson",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:The_India_Gate,_New_Delhi_(5621259188).jpg",
      "license": "CC BY 2.0",
      "licenseUrl": "https://creativecommons.org/licenses/by/2.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "mumbai": {
    "image": "/media/destinations-20261022/mumbai.webp",
    "imageWidth": 1440,
    "imageHeight": 1080,
    "imageSrcSet": "/media/destinations-20261022/mumbai-640.webp 640w, /media/destinations-20261022/mumbai.webp 1440w",
    "imageAlt": "Gateway of India on the Mumbai waterfront",
    "landmarkCaption": "Gateway of India",
    "imagePosition": "center",
    "credit": {
      "title": "Gateway of India, Mumbai, India.jpg",
      "author": "© ShadesofIndia",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Gateway_of_India%2C_Mumbai%2C_India.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "amritsar": {
    "image": "/media/destinations-20261022/amritsar.webp",
    "imageWidth": 1440,
    "imageHeight": 960,
    "imageSrcSet": "/media/destinations-20261022/amritsar-640.webp 640w, /media/destinations-20261022/amritsar.webp 1440w",
    "imageAlt": "Golden Temple in Amritsar glowing in warm morning light beside its sacred pool",
    "landmarkCaption": "Golden Temple",
    "imagePosition": "center",
    "credit": {
      "title": "Golden Temple - Amritsar India.jpg",
      "author": "Wingedtree",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Golden_Temple_-_Amritsar_India.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "omkareshwar": {
    "image": "/media/destinations-20261022/omkareshwar.webp",
    "imageWidth": 1440,
    "imageHeight": 960,
    "imageSrcSet": "/media/destinations-20261022/omkareshwar-640.webp 640w, /media/destinations-20261022/omkareshwar.webp 1440w",
    "imageAlt": "Shri Omkar Mandhata Temple above the Narmada riverfront at Omkareshwar",
    "landmarkCaption": "Shri Omkar Mandhata Temple",
    "imagePosition": "center",
    "credit": {
      "title": "Omkareshwar, Shri Omkar Mandhata (9840595185).jpg",
      "author": "Arian Zwegers",
      "sourceUrl": "https://www.flickr.com/photos/azwegers/9840595185/",
      "license": "CC BY 2.0",
      "licenseUrl": "https://creativecommons.org/licenses/by/2.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "pachmarhi": {
    "image": "/media/destinations-20261022/pachmarhi.webp",
    "imageWidth": 1440,
    "imageHeight": 810,
    "imageSrcSet": "/media/destinations-20261022/pachmarhi-640.webp 640w, /media/destinations-20261022/pachmarhi.webp 1440w",
    "imageAlt": "Cascading upstream waters at Bee Falls in Pachmarhi, Madhya Pradesh",
    "landmarkCaption": "Bee Falls",
    "imagePosition": "center",
    "credit": {
      "title": "Bee Fall @Pachmarhi.jpg",
      "author": "BSSKrishnaS",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Bee_Fall_%40Pachmarhi.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "vrindavan": {
    "image": "/media/destinations-20261022/vrindavan.webp",
    "imageWidth": 1440,
    "imageHeight": 960,
    "imageSrcSet": "/media/destinations-20261022/vrindavan-640.webp 640w, /media/destinations-20261022/vrindavan.webp 1440w",
    "imageAlt": "Prem Mandir in Vrindavan beneath a colourful sunset sky",
    "landmarkCaption": "Prem Mandir",
    "imagePosition": "70% center",
    "credit": {
      "title": "Prem Mandir, Vrindavan",
      "author": "Alexey Komarov",
      "sourceUrl": "https://www.flickr.com/photos/75938119@N04/16251633973/",
      "license": "CC BY 2.0",
      "licenseUrl": "https://creativecommons.org/licenses/by/2.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "haridwar": {
    "image": "/media/destinations-20261022/haridwar.webp",
    "imageWidth": 1440,
    "imageHeight": 960,
    "imageSrcSet": "/media/destinations-20261022/haridwar-640.webp 640w, /media/destinations-20261022/haridwar.webp 1440w",
    "imageAlt": "Har Ki Pauri bathing ghats beside the Ganga in Haridwar in warm morning light",
    "landmarkCaption": "Har Ki Pauri",
    "imagePosition": "center",
    "credit": {
      "title": "Sunrise view of the main bathing ghat at Har-ki-pauri, Haridwar.jpg",
      "author": "Wolfgang Maehr",
      "sourceUrl": "https://www.flickr.com/photos/53908695@N00/3625158098/",
      "license": "CC BY 2.0",
      "licenseUrl": "https://creativecommons.org/licenses/by/2.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "rishikesh": {
    "image": "/media/destinations-20261022/rishikesh.webp",
    "imageWidth": 1440,
    "imageHeight": 1080,
    "imageSrcSet": "/media/destinations-20261022/rishikesh-640.webp 640w, /media/destinations-20261022/rishikesh.webp 1440w",
    "imageAlt": "Ganga riverfront in Rishikesh with a suspension bridge and Himalayan foothills",
    "landmarkCaption": "Ganga riverfront",
    "imagePosition": "center",
    "credit": {
      "title": "View across the Ram Jhula bridge on the Ganges, Muni Ki Reti, Rishikesh.jpg",
      "author": "Ken Wieland",
      "sourceUrl": "https://www.flickr.com/photos/76766199@N00/3639583547/",
      "license": "CC BY-SA 2.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/2.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "ajmer": {
    "image": "/media/destinations-20261022/ajmer.webp",
    "imageWidth": 1440,
    "imageHeight": 1081,
    "imageSrcSet": "/media/destinations-20261022/ajmer-640.webp 640w, /media/destinations-20261022/ajmer.webp 1440w",
    "imageAlt": "A marble pavilion beside Ana Sagar Lake in Ajmer at sunset",
    "landmarkCaption": "Ana Sagar pavilion",
    "imagePosition": "center",
    "credit": {
      "title": "Ana Sagar pavilion sunset 2016.jpg",
      "author": "Logawi",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Ana_Sagar_pavilion_sunset_2016.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "pushkar": {
    "image": "/media/destinations-20261022/pushkar.webp",
    "imageWidth": 1440,
    "imageHeight": 960,
    "imageSrcSet": "/media/destinations-20261022/pushkar-640.webp 640w, /media/destinations-20261022/pushkar.webp 1440w",
    "imageAlt": "Ghats and temples beside Pushkar Lake in Rajasthan",
    "landmarkCaption": "Pushkar Lake",
    "imagePosition": "center",
    "credit": {
      "title": "Pushkar, India, Pushkar Lake.jpg",
      "author": "Vyacheslav Argenberg",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Pushkar%2C_India%2C_Pushkar_Lake.jpg",
      "license": "CC BY 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "mount-abu": {
    "image": "/media/destinations-20261022/mount-abu.webp",
    "imageWidth": 1440,
    "imageHeight": 1080,
    "imageSrcSet": "/media/destinations-20261022/mount-abu-640.webp 640w, /media/destinations-20261022/mount-abu.webp 1440w",
    "imageAlt": "Nakki Lake surrounded by hills in Mount Abu, Rajasthan",
    "landmarkCaption": "Nakki Lake",
    "imagePosition": "center",
    "credit": {
      "title": "NAKKI LAKE, MOUNT ABU, RAJASTHAN.jpg",
      "author": "Colobanche73",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:NAKKI_LAKE%2C_MOUNT_ABU%2C_RAJASTHAN.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "old-delhi": {
    "image": "/media/destinations-20261022/old-delhi.webp",
    "imageWidth": 1440,
    "imageHeight": 1080,
    "imageSrcSet": "/media/destinations-20261022/old-delhi-640.webp 640w, /media/destinations-20261022/old-delhi.webp 1440w",
    "imageAlt": "The Red Fort in Old Delhi",
    "landmarkCaption": "Red Fort",
    "imagePosition": "center",
    "credit": {
      "title": "Delhi Red fort.jpg",
      "author": "Hemant banswal",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Delhi_Red_fort.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "jhansi": {
    "image": "/media/destinations-20261022/jhansi.webp",
    "imageWidth": 1440,
    "imageHeight": 810,
    "imageSrcSet": "/media/destinations-20261022/jhansi-640.webp 640w, /media/destinations-20261022/jhansi.webp 1440w",
    "imageAlt": "Jhansi Fort in Uttar Pradesh",
    "landmarkCaption": "Jhansi Fort",
    "imagePosition": "center",
    "credit": {
      "title": "Jhansi Fort.jpg",
      "author": "Ppan279",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Jhansi_Fort.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "vindhyachal": {
    "image": "/media/destinations-20261022/vindhyachal.webp",
    "imageWidth": 1440,
    "imageHeight": 1920,
    "imageSrcSet": "/media/destinations-20261022/vindhyachal-640.webp 640w, /media/destinations-20261022/vindhyachal.webp 1440w",
    "imageAlt": "Devotional signage and visitor entry at Maa Vindhyavasini Temple in Vindhyachal",
    "landmarkCaption": "Vindhyavasini Temple entrance",
    "imagePosition": "center",
    "credit": {
      "title": "Maa Vindhyavasini temple entrance gate.jpg",
      "author": "Godric_ki_Kothri",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Maa_Vindhyavasini_temple_entrance_gate.jpg",
      "license": "CC BY-SA 3.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "gorakhpur": {
    "image": "/media/destinations-20261022/gorakhpur.webp",
    "imageWidth": 1440,
    "imageHeight": 810,
    "imageSrcSet": "/media/destinations-20261022/gorakhpur-640.webp 640w, /media/destinations-20261022/gorakhpur.webp 1440w",
    "imageAlt": "Gorakhnath Temple in Gorakhpur",
    "landmarkCaption": "Gorakhnath Temple",
    "imagePosition": "center",
    "credit": {
      "title": "Gorakhnath Main Temple.jpg",
      "author": "StarlordHarsh",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Gorakhnath_Main_Temple.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "bikaner": {
    "image": "/media/destinations-20261022/bikaner.webp",
    "imageWidth": 1440,
    "imageHeight": 960,
    "imageSrcSet": "/media/destinations-20261022/bikaner-640.webp 640w, /media/destinations-20261022/bikaner.webp 1440w",
    "imageAlt": "Red sandstone walls and palace facade of Junagarh Fort in Bikaner",
    "landmarkCaption": "Junagarh Fort",
    "imagePosition": "center",
    "credit": {
      "title": "Bikaner, Junagarh",
      "author": "Arian Zwegers",
      "sourceUrl": "https://www.flickr.com/photos/azwegers/6272113088",
      "license": "CC BY 2.0",
      "licenseUrl": "https://creativecommons.org/licenses/by/2.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "ranthambore": {
    "image": "/media/destinations-20261022/ranthambore.webp",
    "imageWidth": 1440,
    "imageHeight": 957,
    "imageSrcSet": "/media/destinations-20261022/ranthambore-640.webp 640w, /media/destinations-20261022/ranthambore.webp 1440w",
    "imageAlt": "Tiger walking through dry woodland in Ranthambore National Park",
    "landmarkCaption": "Ranthambore National Park",
    "imagePosition": "center",
    "credit": {
      "title": "Tiger at Ranthambore National Park - DSC03916",
      "author": "Julian Mason",
      "sourceUrl": "https://www.flickr.com/photos/meandmyshadow/23391808742/",
      "license": "CC BY 2.0",
      "licenseUrl": "https://creativecommons.org/licenses/by/2.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "chittorgarh": {
    "image": "/media/destinations-20261022/chittorgarh.webp",
    "imageWidth": 1440,
    "imageHeight": 1080,
    "imageSrcSet": "/media/destinations-20261022/chittorgarh-640.webp 640w, /media/destinations-20261022/chittorgarh.webp 1440w",
    "imageAlt": "Chittorgarh Fort and its reservoir in Rajasthan",
    "landmarkCaption": "Chittorgarh Fort",
    "imagePosition": "center",
    "credit": {
      "title": "Chittorgarh Fort with lake.jpg",
      "author": "Bhartiya00",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Chittorgarh_Fort_with_lake.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "kota": {
    "image": "/media/destinations-20261022/kota.webp",
    "imageWidth": 1440,
    "imageHeight": 1080,
    "imageSrcSet": "/media/destinations-20261022/kota-640.webp 640w, /media/destinations-20261022/kota.webp 1440w",
    "imageAlt": "The Chambal River near Kota in Rajasthan",
    "landmarkCaption": "Chambal River",
    "imagePosition": "center",
    "credit": {
      "title": "Kota Chambal River.jpg",
      "author": "Neer Rajora",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Kota_Chambal_River.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "dehradun": {
    "image": "/media/destinations-20261022/dehradun.webp",
    "imageWidth": 1440,
    "imageHeight": 810,
    "imageSrcSet": "/media/destinations-20261022/dehradun-640.webp 640w, /media/destinations-20261022/dehradun.webp 1440w",
    "imageAlt": "Forest Research Institute in Dehradun with its domed red-brick buildings and landscaped lawns",
    "landmarkCaption": "Forest Research Institute",
    "imagePosition": "center",
    "credit": {
      "title": "Forest Research Institute, Dehradun Full view.jpg",
      "author": "MR.VIVEK NEGI",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Forest_Research_Institute%2C_Dehradun_Full_view.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "mussoorie": {
    "image": "/media/destinations-20261022/mussoorie.webp",
    "imageWidth": 1440,
    "imageHeight": 960,
    "imageSrcSet": "/media/destinations-20261022/mussoorie-640.webp 640w, /media/destinations-20261022/mussoorie.webp 1440w",
    "imageAlt": "Hillside homes among green slopes in Mussoorie",
    "landmarkCaption": "Mussoorie townscape",
    "imagePosition": "center",
    "credit": {
      "title": "Mussoorie town, Uttarakhand, India.jpg",
      "author": "Pinakpani",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Mussoorie_town%2C_Uttarakhand%2C_India.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "nainital": {
    "image": "/media/destinations-20261022/nainital.webp",
    "imageWidth": 1440,
    "imageHeight": 960,
    "imageSrcSet": "/media/destinations-20261022/nainital-640.webp 640w, /media/destinations-20261022/nainital.webp 1440w",
    "imageAlt": "Boats on Naini Lake with wooded hills and Nainital homes around the shore",
    "landmarkCaption": "Naini Lake",
    "imagePosition": "center",
    "credit": {
      "title": "Naini Lake, Nainital, Uttarakhand, India.jpg",
      "author": "Praveen Singh Bisht",
      "sourceUrl": "https://www.flickr.com/photos/191825506@N07/54408680477/",
      "license": "CC BY 2.0",
      "licenseUrl": "https://creativecommons.org/licenses/by/2.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "kedarnath": {
    "image": "/media/destinations-20261022/kedarnath.webp",
    "imageWidth": 1440,
    "imageHeight": 648,
    "imageSrcSet": "/media/destinations-20261022/kedarnath-640.webp 640w, /media/destinations-20261022/kedarnath.webp 1440w",
    "imageAlt": "Kedarnath Temple decorated with marigolds against snowy Himalayan peaks",
    "landmarkCaption": "Kedarnath Temple",
    "imagePosition": "center",
    "credit": {
      "title": "Kedarnath temple in uttarakhand.jpg",
      "author": "Nehasnaps0306",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Kedarnath_temple_in_uttarakhand.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "badrinath": {
    "image": "/media/destinations-20261022/badrinath.webp",
    "imageWidth": 1440,
    "imageHeight": 960,
    "imageSrcSet": "/media/destinations-20261022/badrinath-640.webp 640w, /media/destinations-20261022/badrinath.webp 1440w",
    "imageAlt": "Colourful entrance facade of Badrinath Temple beneath the mountains",
    "landmarkCaption": "Badrinath Temple",
    "imagePosition": "center",
    "credit": {
      "title": "Badrinath Temple.jpg",
      "author": "Harshit SR",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Badrinath_Temple.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "gangotri": {
    "image": "/media/destinations-20261022/gangotri.webp",
    "imageWidth": 1440,
    "imageHeight": 1080,
    "imageSrcSet": "/media/destinations-20261022/gangotri-640.webp 640w, /media/destinations-20261022/gangotri.webp 1440w",
    "imageAlt": "White domes and carved entrance of Gangotri Temple with pilgrims in the courtyard",
    "landmarkCaption": "Gangotri Temple",
    "imagePosition": "center top",
    "credit": {
      "title": "Gangotri temple in Uttarakhand..jpg",
      "author": "Arupamdas",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Gangotri_temple_in_Uttarakhand..jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "yamunotri": {
    "image": "/media/destinations-20261022/yamunotri.webp",
    "imageWidth": 1440,
    "imageHeight": 960,
    "imageSrcSet": "/media/destinations-20261022/yamunotri-640.webp 640w, /media/destinations-20261022/yamunotri.webp 1440w",
    "imageAlt": "Yamunotri Temple in the Garhwal Himalayas of Uttarakhand",
    "landmarkCaption": "Yamunotri Temple",
    "imagePosition": "center",
    "credit": {
      "title": "Yamunotri shrine.jpg",
      "author": "AaS",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Yamunotri_shrine.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "jim-corbett": {
    "image": "/media/destinations-20261022/jim-corbett.webp",
    "imageWidth": 1440,
    "imageHeight": 1080,
    "imageSrcSet": "/media/destinations-20261022/jim-corbett-640.webp 640w, /media/destinations-20261022/jim-corbett.webp 1440w",
    "imageAlt": "Grasslands in Jim Corbett National Park, Uttarakhand",
    "landmarkCaption": "Jim Corbett National Park",
    "imagePosition": "center bottom",
    "credit": {
      "title": "Grasslands in Jim Corbett.jpg",
      "author": "Japleenpasricha",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Grasslands_in_Jim_Corbett.jpg",
      "license": "CC BY-SA 4.0",
      "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  },
  "auli": {
    "image": "/media/destinations-20261022/auli.webp",
    "imageWidth": 1440,
    "imageHeight": 810,
    "imageSrcSet": "/media/destinations-20261022/auli-640.webp 640w, /media/destinations-20261022/auli.webp 1440w",
    "imageAlt": "Mountain scenery at Auli in Uttarakhand",
    "landmarkCaption": "Auli Himalayan landscape",
    "imagePosition": "center",
    "credit": {
      "title": "Auli, India.jpg",
      "author": "Amit Shaw",
      "sourceUrl": "https://commons.wikimedia.org/wiki/File:Auli,_India.jpg",
      "license": "CC0 1.0",
      "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/",
      "changes": "Resized and converted to WebP; display may be cropped. Licensed as shown."
    }
  }
};
